import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OnlineMeeting } from '@microsoft/microsoft-graph-types';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TeamsMeetingDTO } from '../models/teams-meeting.model';
import { MeetingCrudService } from '../models/meeting-crud-service.model';
import { MeetingCreationResult } from '../models/meeting-creation-result.model';
import { MeetingLinkDocentDTO } from '../models/meeting-link-docent-dto.model';

@Injectable({
  providedIn: 'root',
})
export class TeamsDocentMeetingService implements MeetingCrudService {
  private apiUrl = environment.apiUrl + '/teamsmeeting/docent';

  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Je ein Meeting pro Schultag im konfigurierten Zeitraum.
   * @returns Laufergebnis mit einer Zeile je Tag; 200 auch ohne Erstellungen.
   */
  create(
    meeting: OnlineMeeting,
    name: string,
  ): Observable<MeetingCreationResult> {
    return this.httpClient.post<MeetingCreationResult>(this.apiUrl, meeting, {
      params: new HttpParams().set('name', name),
    });
  }

  /**
   * Aktualisiert ein bestehendes Teams Meeting.
   * @param meetingId Die ID des Meetings.
   * @param meeting Die aktualisierten Daten des Meetings.
   * @returns TeamsMeetingDTO Observable mit dem aktualisierten Teams Meeting.
   */
  update(
    meetingId: string,
    meeting: OnlineMeeting,
  ): Observable<TeamsMeetingDTO> {
    return this.httpClient.put<TeamsMeetingDTO>(
      `${this.apiUrl}/${encodeURIComponent(meetingId)}`,
      meeting,
    );
  }

  /**
   * Löscht ein Teams Meeting anhand der Meeting-ID.
   * @param meetingId Die ID des Meetings.
   * @returns Observable<void>
   */
  delete(meetingId: string): Observable<void> {
    return this.httpClient.delete<void>(
      `${this.apiUrl}/${encodeURIComponent(meetingId)}`,
    );
  }

  /**
   * Holt alle Teams Meeting Links für Dozenten.
   * @param docentName Optional: Filtert die Meeting Links auf einen einzelnen Dozenten.
   * @param from Optional: Startdatum (DateOnly, z. B. "2026-01-01") für den Filterzeitraum.
   * @param to Optional: Enddatum (DateOnly, z. B. "2026-01-31") für den Filterzeitraum.
   */
  getAll(
    docentName?: string,
    from?: string,
    to?: string,
  ): Observable<MeetingLinkDocentDTO[]> {
    let params = new HttpParams();
    if (docentName) {
      params = params.set('docentName', docentName);
    }
    if (from) {
      params = params.set('from', from);
    }
    if (to) {
      params = params.set('to', to);
    }
    return this.httpClient.get<MeetingLinkDocentDTO[]>(`${this.apiUrl}/all`, {
      params,
    });
  }

  /** Fehlende Meetings für alle Dozenten aus dem Stundenplan. */
  createAll(): Observable<MeetingCreationResult> {
    return this.httpClient.post<MeetingCreationResult>(
      `${this.apiUrl}/all`,
      {},
    );
  }
}
